export default __webpack_public_path__ + "static/media/productsImage7.897e61af.svg";